import React from 'react'
import { createFunkGoPage } from '../FunkGoPage'
import { createTransportContext } from '../utils/transportContext'

/* --------------------------------------- */
const assertSinglePageOptions = ({ component, pluginHub }) => {
  if (!component || !pluginHub) {
    throw new Error('invalid parameter to render single page elements')
  }
}

const getLocation = ({ location = window.location }) => location

/* --------------------------------------- */

const createAppShell = ({ AppShell, pluginHub }) => {
  return props => {
    const transportContext = createTransportContext({
      location: getLocation(props)
    })

    const pluginProps = pluginHub.getInjectProps(transportContext)

    return (
      <AppShell {...pluginProps}>{props.children}</AppShell>
    )
  }
}

/* --------------------------------------- */

const createRouter = () => props => props.children

/* --------------------------------------- */

const createPageElements = options => props => {
  assertSinglePageOptions(options)
  const Component = createFunkGoPage(options.component, options.pluginHub)
  const location = getLocation(props)

  return (
    <Component {...props} location={location} ></Component>
  )
}

/* --------------------------------------- */

const createMatchPage = options => () => {
  assertSinglePageOptions(options)

  return {
    Component: createFunkGoPage(options.component, options.pluginHub),
    statusCode: 200,
    match: null,
  }
}

/* --------------------------------------- */

export {
  createAppShell,
  createRouter,
  createPageElements,
  createMatchPage,
}